import { ChoiceWrapper, ChoiceWrapperItem } from '@flixbus/honeycomb-react';

import { useVoucherFormContext } from '../../Context';
import { WeekdaysTravelRule } from '../../../../types/Rules';
import { daysOfWeek } from './daysOfWeek';

import formStyles from '../../voucher-form.module.scss';

const Weekdays = () => {
  const {
    formState: {
      payload: { rules },
    },
    handleRuleChange,
  } = useVoucherFormContext();

  const ruleValue = rules.filter(r => r.type === 'weekdays_travel')[0] as
    | WeekdaysTravelRule
    | undefined;

  return (
    <ChoiceWrapper extraClasses={formStyles.inputLarge} multi legend='Allowed weekdays:'>
      {Object.keys(daysOfWeek).map(d => (
        <ChoiceWrapperItem
          key={d}
          id={d}
          value={daysOfWeek[d]}
          name={daysOfWeek[d]}
          label={d}
          extraClasses={formStyles.choiceWrapper}
          checked={ruleValue?.weekDays ? ruleValue.weekDays.includes(daysOfWeek[d]) : false}
          onChange={e => {
            const newVal = e.target.checked
              ? [...(ruleValue?.weekDays || []), daysOfWeek[d]]
              : ruleValue?.weekDays?.filter(r => r !== daysOfWeek[d]) || [];

            handleRuleChange(
              {
                type: 'weekdays_travel',
                weekDays: newVal,
              },
              newVal.length === 0,
            );
          }}
        />
      ))}
    </ChoiceWrapper>
  );
};

export default Weekdays;
